import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54795451"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "required" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "required" }
const _hoisted_48 = { class: "col-lg-8 fv-row" }
const _hoisted_49 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "row mb-6" }
const _hoisted_59 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_60 = { class: "col-lg-8 fv-row" }
const _hoisted_61 = { class: "row mb-6" }
const _hoisted_62 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "required" }
const _hoisted_64 = { class: "col-lg-8 fv-row" }
const _hoisted_65 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { class: "row mb-6" }
const _hoisted_70 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_71 = { class: "required" }
const _hoisted_72 = { class: "col-lg-8 fv-row" }
const _hoisted_73 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_74 = ["value"]
const _hoisted_75 = { class: "fv-plugins-message-container" }
const _hoisted_76 = { class: "fv-help-block" }
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "required" }
const _hoisted_80 = { class: "col-lg-8 fv-row" }
const _hoisted_81 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_82 = ["value"]
const _hoisted_83 = { class: "fv-plugins-message-container" }
const _hoisted_84 = { class: "fv-help-block" }
const _hoisted_85 = { class: "row mb-6" }
const _hoisted_86 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_87 = { class: "required" }
const _hoisted_88 = { class: "col-lg-8 fv-row" }
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "row mb-6" }
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "required" }
const _hoisted_94 = { class: "col-lg-8 fv-row" }
const _hoisted_95 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_96 = ["value"]
const _hoisted_97 = { class: "fv-plugins-message-container" }
const _hoisted_98 = { class: "fv-help-block" }
const _hoisted_99 = { class: "row mb-6" }
const _hoisted_100 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_101 = { class: "required" }
const _hoisted_102 = { class: "col-lg-8 fv-row" }
const _hoisted_103 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_104 = ["value"]
const _hoisted_105 = { class: "fv-plugins-message-container" }
const _hoisted_106 = { class: "fv-help-block" }
const _hoisted_107 = { class: "row mb-6" }
const _hoisted_108 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_109 = { class: "col-lg-8 fv-row" }
const _hoisted_110 = { class: "row mb-6" }
const _hoisted_111 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_112 = { class: "col-lg-8 fv-row" }
const _hoisted_113 = { class: "row mb-6" }
const _hoisted_114 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_115 = { class: "col-lg-8 fv-row" }
const _hoisted_116 = { class: "row mb-6" }
const _hoisted_117 = { class: "col-lg-4 col-form-label fw-bold fs-6 required" }
const _hoisted_118 = { class: "col-lg-8 fv-row" }
const _hoisted_119 = { class: "fv-plugins-message-container" }
const _hoisted_120 = { class: "fv-help-block" }
const _hoisted_121 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_122 = { class: "col-lg-4 col-form-label fw-bold fs-6 required" }
const _hoisted_123 = { class: "col-lg-8 fv-row" }
const _hoisted_124 = { class: "fv-plugins-message-container" }
const _hoisted_125 = { class: "fv-help-block" }
const _hoisted_126 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_127 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_128 = { class: "indicator-label" }
const _hoisted_129 = { class: "indicator-progress" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Attachment = _resolveComponent("Attachment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'settings'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewHorse')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('English Name')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nameEn",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('English Name')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "nameEn" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('Arabic Name')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nameAr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Arabic Name')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "nameAr" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('chipNumber')), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "chipNumber",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('chipNumber')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ErrorMessage, { name: "chipNumber" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('dateOfBirth')), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.dateOfBirth,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
                        type: "date",
                        name: "dateOfBirth",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DatePicker, {
                            id: "dateOfBirth",
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: _ctx.dateOfBirth,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
                            placeholder: _ctx.translate('dd/mm/yyyy'),
                            fieldId: "dateOfBirth",
                            "today-only": true
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "dateOfBirth" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('joiningDate')), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "joiningDate",
                        modelValue: _ctx.joiningDate,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.joiningDate) = $event)),
                        placeholder: _ctx.translate('joiningDate')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DatePicker, {
                            id: "joiningDate",
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: _ctx.joiningDate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.joiningDate) = $event)),
                            placeholder: _ctx.translate('dd/mm/yyyy'),
                            fieldId: "joiningDate",
                            "today-only": true
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_ErrorMessage, { name: "joiningDate" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate('Gender')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "genderId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.gender,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.gender) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.translate('gender')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderList, (gender) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: gender.id,
                              value: gender.id
                            }, _toDisplayString(gender.nameEn), 9, _hoisted_37))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_ErrorMessage, { name: "genderId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.translate('Passport')), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "passport",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Passport')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_ErrorMessage, { name: "passport" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("label", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.translate('passportType')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "passportTypeId",
                        modelValue: _ctx.passportType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passportType) = $event)),
                        class: "form-select form-select-solid form-select-lg text-capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.translate('passportType')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passportTypeList, (passport) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: passport.id,
                              value: passport.id
                            }, _toDisplayString(passport.nameEn), 9, _hoisted_50))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_ErrorMessage, { name: "passportTypeId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('nationality')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "nationalityId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.nationalityId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nationalityId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_56, _toDisplayString(_ctx.translate('nationality')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nationalityList, (role) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: role.id,
                              value: role.id
                            }, _toDisplayString(role.nameEn), 9, _hoisted_57))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.translate('Dam')), 1),
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "dam",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Dam'),
                        value: ""
                      }, null, 8, ["placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, [
                      _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.translate('status')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "statusId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.status,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.status) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.translate('status')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (status) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: status.id,
                              value: status.id
                            }, _toDisplayString(status.nameEn), 9, _hoisted_66))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_component_ErrorMessage, { name: "statusId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("label", _hoisted_70, [
                      _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.translate('Horse Category')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "categoryId",
                        modelValue: _ctx.horseCategory,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.horseCategory) = $event)),
                        class: "form-select form-select-solid form-select-lg text-capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_73, _toDisplayString(_ctx.translate('category')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: category.id,
                              value: category.id
                            }, _toDisplayString(category.nameEn), 9, _hoisted_74))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createVNode(_component_ErrorMessage, { name: "categoryId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", _hoisted_78, [
                      _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.translate('Horse color')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "colorId",
                        modelValue: _ctx.horseColor,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.horseColor) = $event)),
                        class: "form-select form-select-solid form-select-lg text-capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_81, _toDisplayString(_ctx.translate('color')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorList, (color) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: color.id,
                              value: color.id
                            }, _toDisplayString(color.nameEn), 9, _hoisted_82))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, [
                          _createVNode(_component_ErrorMessage, { name: "colorId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("label", _hoisted_86, [
                      _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.translate('Horse Location')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createVNode(_component_Field, {
                        name: "horseLocationId",
                        modelValue: _ctx.horseLocation,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.horseLocation) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SearchField, {
                            modelValue: _ctx.horseLocation,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.horseLocation) = $event)),
                            options: _ctx.horseLocationList,
                            mode: "single",
                            label: _ctx.translate('Select Horse Location'),
                            className: "form-select-md",
                            trackBy: "nameEn"
                          }, null, 8, ["modelValue", "options", "label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createVNode(_component_ErrorMessage, { name: "horseLocationId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("label", _hoisted_92, [
                      _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.translate('Horse breed')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "breedId",
                        modelValue: _ctx.horseBreed,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.horseBreed) = $event)),
                        class: "form-select form-select-solid form-select-lg text-capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_95, _toDisplayString(_ctx.translate('Breed')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breedList, (breed) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: breed.id,
                              value: breed.id
                            }, _toDisplayString(breed.nameEn), 9, _hoisted_96))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createVNode(_component_ErrorMessage, { name: "breedId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, [
                      _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.translate('Horse type')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "typeId",
                        modelValue: _ctx.horseType,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.horseType) = $event)),
                        class: "form-select form-select-solid form-select-lg text-capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_103, _toDisplayString(_ctx.translate('Horse Type')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horseTypeList, (type) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: type.id,
                              value: type.id
                            }, _toDisplayString(type.nameEn), 9, _hoisted_104))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createVNode(_component_ErrorMessage, { name: "typeId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.translate('Sire')), 1),
                    _createElementVNode("div", _hoisted_109, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "sire",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Sire'),
                        value: ""
                      }, null, 8, ["placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.translate('workCapacity')), 1),
                    _createElementVNode("div", _hoisted_112, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "workCapacity",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('workCapacity'),
                        value: ""
                      }, null, 8, ["placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.translate('Class Limit Per Day ')), 1),
                    _createElementVNode("div", _hoisted_115, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "classLimitPerDay",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Class Limit Per Day'),
                        value: 0
                      }, null, 8, ["placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("label", _hoisted_117, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('Owner Name')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createVNode(_component_Field, {
                        name: "customerId",
                        modelValue: _ctx.customerId,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customerId) = $event)),
                        class: "form-select form-select-solid form-select-lg text-capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SearchField, {
                            modelValue: _ctx.customerId,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customerId) = $event)),
                            options: _ctx.customerList,
                            mode: "single",
                            label: _ctx.translate('customer'),
                            className: "form-select-md"
                          }, null, 8, ["modelValue", "options", "label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _createVNode(_component_ErrorMessage, { name: "customerId" })
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.isHorseKRCPrivate || _ctx.isHorsePrivate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                        _createElementVNode("label", _hoisted_122, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.translate('Riders')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_123, [
                          _createVNode(_component_Field, { name: "ridersId" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Multiselect, {
                                mode: "tags",
                                "close-on-select": false,
                                requierd: false,
                                label: "name",
                                trackBy: "name",
                                searchable: true,
                                canDeselect: false,
                                placeholder: _ctx.translate('Select riders'),
                                valueProp: "id",
                                options: _ctx.customerList,
                                noResultsText: _ctx.translate('noResultsFound'),
                                "allow-empty": false,
                                required: true,
                                modelValue: _ctx.ridersId,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ridersId) = $event))
                              }, null, 8, ["placeholder", "options", "noResultsText", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("div", _hoisted_125, [
                              _createVNode(_component_ErrorMessage, { name: "ridersId" })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", _hoisted_127, [
                    _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_129, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_130
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Attachment, {
      isDisabled: !_ctx.horseId,
      onSubmitCreate: _ctx.onSubmitCreateAttachment
    }, null, 8, ["isDisabled", "onSubmitCreate"])
  ], 64))
}